<template>
  <v-sheet>
    <Title class="text-center">Contato</Title>

    <v-container class="pt-6 pb-0">
      <v-row justify="center">
        <v-col cols="12" md="10" lg="8">
          <v-sheet
            width="100%"
            :height="xs ? `160px` : `200px`"
            class="contact-map rounded"
            v-if="map"
            v-html="map"
          />
        </v-col>
      </v-row>
    </v-container>

    <v-container class="pt-8 pb-10 pt-lg-10 pb-lg-16">
      <v-row justify="center">
        <v-col cols="12" md="8" lg="7" class="text-center">
          <p
            class="
              primary--text
              text-h6 text-md-h5
              font-weight-medium
              mb-6 mb-md-8
            "
          >
            Entre em contato conosco pelo whatsapp
          </p>

          <v-btn
            v-if="whatsappLink"
            :href="whatsappLink"
            target="_blank"
            color="success"
            class="white--text py-4 px-12 font-weight-bold text-none"
            rounded
            depressed
            height="42"
          >
            <v-icon size="20" class="mr-2">fab fa-whatsapp</v-icon>
            Enviar mensagem
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script>
import Title from "../widgets/Title.vue";
import { getWhatsappLinkFromPhone } from "../../utils/getWhatsappLinkFromPhone";

export default {
  computed: {
    informations() {
      if (!this.$rest("informations").item) return null;
      return this.$rest("informations").item;
    },
    map() {
      if (!this.informations || !this.informations.map) return "";
      return this.informations.map;
    },
    xs() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    whatsappLink() {
      if (!this.informations) return "";

      if (this.informations.whatsapp) return this.informations.whatsapp;
      if (this.informations.tel) {
        return getWhatsappLinkFromPhone(this.informations.tel);
      }

      return "";
    },
  },
  components: {
    Title,
  },
};
</script>

<style lang="scss">
.contact-map {
  overflow: hidden;

  iframe {
    width: 100% !important;
    height: 100% !important;
  }
}
</style>
